/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_TitleInputs */

const cs_calendar_sync_title = /** @type {(inputs: Calendar_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat do kalendáře`)
};

const en_calendar_sync_title = /** @type {(inputs: Calendar_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to calendar`)
};

/**
* | output |
* | --- |
* | "Sync to calendar" |
*
* @param {Calendar_Sync_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_title = /** @type {((inputs?: Calendar_Sync_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_title(inputs)
	return cs_calendar_sync_title(inputs)
});